const SI_SYMBOL = ['', 'k', 'M', 'G', 'T', 'P', 'E']

const trim = (text, length) =>
  text?.length > length ? `${text.substring(0, length)}...` : `${text}`

const valueOrEmptyString = value => value || ''

const toBoolean = value => value && value !== 'false'

const splitTextInTwo = text => {
  const lastSpaceIndex = text.lastIndexOf(' ')
  if (lastSpaceIndex === -1) {
    return [text]
  }

  return [text.substring(0, lastSpaceIndex), text.substring(lastSpaceIndex)]
}

const capitalizeFirstLetter = string => string && string.charAt(0).toUpperCase() + string.slice(1)

// https://stackoverflow.com/a/40724354/2959774
const millify = number => {
  // what tier? (determines SI symbol)
  const tier = (Math.log10(Math.abs(number)) / 3) | 0

  // if zero, we don't need a suffix
  if (tier === 0) return number

  // get suffix and determine scale
  const suffix = SI_SYMBOL[tier]
  const scale = Math.pow(10, tier * 3)

  // scale the number
  const scaled = number / scale

  // format number and add suffix
  return scaled.toFixed(1) + suffix
}

export { trim, valueOrEmptyString, splitTextInTwo, capitalizeFirstLetter, millify, toBoolean }
